import { render, staticRenderFns } from "./SortingCard.vue?vue&type=template&id=347ea958&"
import script from "./SortingCard.vue?vue&type=script&lang=js&"
export * from "./SortingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports